
<template>
<div>
    <p style="color: red;">您当前下载剩余次数：{{ dowNum }}</p>
    <div style="display: flex; justify-content: end;margin-right: 20px;">
        <el-button type="primary" @click="clickBatchMove">批量移动</el-button>
        <el-button type="primary" @click="clickBatchDownload">批量下载</el-button>
    </div>
    <el-table ref="tables" v-if="dataFile.list && dataFile.list.length > 0"  :data="dataFile.list" height="540" stripe style="width: 100%; " :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  @selection-change="handleSelectionChange">
        <el-table-column label="序号" type="selection"></el-table-column>
        <el-table-column  prop="realname" show-overflow-tooltip label="文件名" width="380">
            <template slot-scope="scope">
                <span style="color:#4992df;display: flex;" @click="handleClickDep(scope.row,'预览')">{{ scope.row.fileName }}</span>
            </template>
        </el-table-column>
        <el-table-column  label="操作" width="250">
            <template slot-scope="scope">
                <span style="color:#4992df;padding: 0px 5px;" @click="handleClickDep(scope.row,'下载')">下载</span>
                <span style="color:#4992df;padding: 0px 5px;" @click="handleClickDep(scope.row,'删除')">删除</span>
            </template>
        </el-table-column>
        <el-table-column  prop="creatorName" show-overflow-tooltip label="创建者" ></el-table-column>
        <el-table-column  prop="createTime" show-overflow-tooltip label="创建时间" width="180"></el-table-column>
    </el-table>
    <el-empty  v-else description="暂时没有可用文件哦~"></el-empty>

    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="fromData.pageNo"
        :page-size="fromData.pageSize"
        :total="fromData.total"
        layout="prev, pager, next,sizes,jumper">
    </el-pagination>

    <el-dialog title="预览图片" width="50%" style="padding: 0px 50px;" :visible.sync="showInfo" :before-close="showshowInfoViewInfoCler" :close-on-click-modal="false">
        <Guciya v-if="showInfo" :url="urls" ></Guciya>
    </el-dialog>

    <el-dialog title="预览" width="60%" style="padding: 0px 50px;" :visible.sync="showImgDing" :before-close="showImgDingClers5" :close-on-click-modal="false">
        <div style="margin-bottom: 20px;">
            <!-- <el-button :theme="'default'"  type="submit" :title="'基础按钮'" @click.stop="handleDownload1" class="mr10"> 下 载</el-button> -->
        </div>
        <div>
            <img :src="showImgDingurlsss" :alt="showImgDingurlsss" style="width: 100%;">
        </div>
    </el-dialog>

    <el-dialog title="预览" width="60%" style="padding: 0px 50px;" :visible.sync="showInfos" :before-close="showshowInfoViewInfoClers" :close-on-click-modal="false">
        <!-- <el-button :theme="'default'"  type="submit" :title="'基础按钮'" @click.stop="handleDownload" class="mr10"> 下 载</el-button> -->
        <!-- <el-button :theme="'default'"  type="submit" :title="'基础按钮'"  class="mr10">暂无预览~</el-button> -->
        <GuciYa-VueOfficeDocx :src="docxContent" ref="docxEditor" :options="editorOptions"></GuciYa-VueOfficeDocx>
    </el-dialog>

    <el-dialog title="移动到哪个文件下" width="60%" style="padding: 0px 50px;" :visible.sync="showfilesDing" :before-close="beforeShowfile" :close-on-click-modal="false">
        <el-tree
            ref="trees"
            style="width: 50%;"
            :data="fileDataList"
            show-checkbox
            node-key="id"
            default-expand-all
            current-node-key
            :expand-on-click-node="false"
            :allow-drop="allowDrop"
            :allow-drag="allowDrag"
            @check="handleCheck"
            :props="fileDefaultProps">
        </el-tree>

        <div><el-button type="primary" @click="handleClickOk">确定</el-button></div>
    </el-dialog>



</div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from "../utils/loading";
import { getSubject,} from "@/api/firstClassApi";
import { deleteFile } from "@/api/fileSpace.js";

import Guciya from "../InterviewManagement/components/Guciya-compoents";
import { el } from "@fullcalendar/core/internal-common";



export default {
components: { Guciya },
props:{
    dataFile:{
        default:{},
        type: Object
    },
    fromData:{
        default:{},
        type: Object
    },
    fileDataList:{
        default:[],
        type: Array
    }
},
data(){
    return{
        fileDefaultProps:{
        children: "children",
        label: "folderName",
        },
        showfilesDing:false,

        // tableData: [
        //   {
        //     realname:'要使用layui.tree是还需要下载其他的库嘛',
        //     telephone:'haha',
        //     teachName:'2021-10-12 12:12:12',
        //   }
        // ],
        editorOptions: {
            toolbar: true,
            width: '800px',
            height: '600px'
        },

        showInfo:false,
        urls:'',
        docxContent:'',
        showInfos:false,
        showImgDingurlsss:'',
        showImgDing:false,


        pageNo:1,
        pageSize:10,
        total: 10,

        dataList:{},

        fileUrlList:[],
        fileNameList:[],
        fileid: [],
        // fileids:[],
        categoryId:'',

        dowNum:0,


    }
},
mounted(){
    this.$EventBus.$on("handleBrotherEevet", (e) => {
        
        this.dataList = e

    });

    this.getDownum()


},
    methods: {

    getDownum() {
        this.$axios.get(`${apiBaseUrl}/downloadNum/getAdminResidueNum/${1}`,{
        headers:{
                'authorization':sessionStorage.getItem('tokenInfo')
            }
        }).then((res) => {
            if (res.data.code === 200) {
                this.dowNum = res.data.data
            } else {
                this.$message.error(res.data.message)
            }
                
            })     
    },
    beforeShowfile(){
        this.showfilesDing = false
        this.$refs.trees.setCheckedKeys([]); 
    },


    handleDownload(){
        let ele = document.createElement('a')
        ele.setAttribute('href', this.docxContent)
        document.body.appendChild(ele)
        ele.click()
    },
    showshowInfoViewInfoClers(){
        this.showInfos = false
    },
    handleDownload1(){
        let ele = document.createElement('a')
        ele.setAttribute('href', this.showImgDingurlsss)
        document.body.appendChild(ele)
        ele.click()
    },
    showImgDingClers5(){
        this.showImgDing = false
        this.showImgDingurlsss = ''
    },
    handleTreeClick(type, node, data){

        if(type === '添加部门'){
            this.parentNode = node
            this.dialogVisibleAddDepTitle = '添加部门'
            this.dialogVisibleAddDep = true
        }

        if(type === '编辑部门'){
            this.dialogVisibleAddDepTitle = '编辑部门'
            this.depName = data.deptName
            this.depNameID = data.id
            this.dialogVisibleAddDep = true
        }

        if(type === '删除部门'){
            this.$confirm('此操作将删除【教师部】， 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                this.handleDelete(data.id)
            }).catch(() => {
                this.$message({ type: 'info', message: '已取消删除' })
            })
        }

    },

    allowDrop(draggingNode, dropNode, type) {
        return dropNode.data.deptName !== '蒙正课堂';
    },

    allowDrag(draggingNode) {
        return draggingNode.data.deptName !== '蒙正课堂';
    },

    handleDrop(draggingNode, dropNode, dropType, ev) {
        let { parent, data } = draggingNode

        this.SonNodeID = data.deptId
        this.handleMove()
    },

    handleClickTree(data){
        this.isDisplay = data.isDisplay == 1 ? true : false
        this.isID = data.deptId
        this.isIDS = data.id
        this.handlegetOrgStaffs()
        this.ShowResignationView = false
    },

    handleDragEnter(draggingNode, dropNode, ev) {
        let { data } = dropNode

        this.ParentLevelD = data.deptId
    },
    handleInput(e){
        axios.get(`${apiBaseUrl}/organizational/getOrgTree?deptName=${e}`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
            if(res.data.data){
                this.dataTree = res.data.data
            }else{
                this.dataTree = []
            }
        })
    },

    getFileName(name) { return name.substring(name.lastIndexOf("."))
    },
    showshowInfoViewInfoCler(){
            this.showInfo = false
    },


upgradeToHttps(urlString) {
    const hasHttps = urlString.includes('https://');

    if (!hasHttps && urlString.includes('http://')) {
        return urlString.replace('http://', 'https://');
    } else {
        return urlString;
    }
},

    issoN(str){
        try {
            JSON.parse(str)
            return true
        } catch(e){
            return false
        }
    },

    handleClickDep(row,type) {



    const replacedString = row.fileUrl.replace('+', '%2B')
    const replacedStrings = this.upgradeToHttps(replacedString)
    row.fileUrl = replacedStrings


    if(type === '预览'){


          if(this.issoN(row.fileUrl)){


            let JsonUrls = JSON.parse(row.fileUrl)
            let JsonUrl = ''
            if(JsonUrls && Array.isArray(JsonUrls)){
                JsonUrl = JsonUrls[0].url
            }else{
                JsonUrl = JsonUrls.url
            }

            if(JsonUrl){
              if(this.getFileName(JsonUrl) === ".pdf"){
                    this.urls = JsonUrl
                    this.showInfo = true
                }else if (this.getFileName(JsonUrl) === ".docx" || this.getFileName(JsonUrl) === ".doc"){
                    this.docxContent = JsonUrl
                    this.showInfos = true
                }else{
                    if(this.getFileName(JsonUrl) === ".jpg" || this.getFileName(JsonUrl) === ".png"){
                        this.showImgDingurlsss = JsonUrl
                        this.showImgDing = true
                    }
                    else if(this.getFileName(JsonUrl) === ".zip"){
                        this.$message({type: 'warning', message: '当前为压缩包暂不支持预览~' })
                    }
                    else{
                        this.$message({type: 'warning', message: '请检查是否为有效的文件类型~' })
                    }
                }
            }

          }else{
            if(row.fileUrl){
              if(this.getFileName(row.fileUrl) === ".pdf"){
                    this.urls = row.fileUrl
                    this.showInfo = true
                }else if (this.getFileName(row.fileUrl) === ".docx" || this.getFileName(row.fileUrl) === ".doc"){
                    this.docxContent = row.fileUrl
                    this.showInfos = true
                }else{
                    if(this.getFileName(row.fileUrl) === ".jpg" || this.getFileName(row.fileUrl) === ".png"){
                        this.showImgDingurlsss = row.fileUrl
                        this.showImgDing = true
                    }
                    else if(this.getFileName(row.fileUrl) === ".zip"){
                        this.$message({type: 'warning', message: '当前为压缩包暂不支持预览~' })
                    }
                    else{
                        this.$message({type: 'warning', message: '请检查是否为有效的文件类型~' })
                    }
                }
            }
          }
    }


    if(type === '下载'){
        // 

        //   const replacedString = row.fileUrl.replace('+', '%2B')
        //   const replacedStrings = this.upgradeToHttps(replacedString)
        //   var link = document.createElement('a')
        //   link.href = replacedStrings
        //   link.download = row.fileName
        //   link.style.display = 'none'
        //   document.body.appendChild(link)
        //   link.click()
        //   document.body.removeChild(link)

        // const replacedString = row.fileUrl.replace('+', '%2B');
        // const replacedStrings = this.upgradeToHttps(replacedString);
        // const encodedFileName = encodeURIComponent(row.fileName); // 对文件名进行编码
        // 

        // var link = document.createElement('a');
        // link.href = replacedStrings;
        // link.download = encodedFileName; // 使用编码后的文件名
        // link.style.display = 'none';
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);

        if (this.dowNum <= 0) {
            this.$message.error(`您目前剩余下载数量为${this.dowNum}个文件`)
        } else {
        let data = {
            callerType: 1,
            fileId:row.id,
            consumeNum: 1,
            downloadType:1,
        }
        this.$axios.post(`${apiBaseUrl}/fileDownload/fileDownloadRecord`, data,{
            headers:{
                'authorization':sessionStorage.getItem('tokenInfo')
            }
            }).then((res)=>{
                
            if(res.data.code === 200){
                this.$emit('handleEventGetListFile' ,this.dataList.folderId,)
                this.getDownum()

                const replacedString = row.fileUrl.replace('+', '%2B');
                const replacedStrings = this.upgradeToHttps(replacedString);

                const fileExtension = row.fileUrl.split('.').pop().toLowerCase();

                fetch(replacedStrings)
                .then(response => response.blob())
                .then(blob => {
                    const link = document.createElement('a');
                    const url = window.URL.createObjectURL(blob);
                    link.href = url;
                    let fileName = row.fileName;
                if (!fileName.toLowerCase().endsWith('.' + fileExtension)) {
                    fileName += '.' + fileExtension;
                }
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                })

                    
            }else{
                this.$message({
                type: "error",
                message: res.data.message,
            });
            }
            })

        }

        


}


    if(type === '删除'){
          this.$confirm('此操作将删除资料， 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {

              deleteFile(row.id).then(res=>{
                if(res.code === 200){
                    this.$emit('handleEventGetListFile' ,row.folderId)
                    this.$message.success('删除成功')
                }else{
                    this.$message.error(res.message)
                }
              })
          }).catch(() => {
              this.$message({ type: 'info', message: '已取消删除' })
          })
    }

    },

    handleSizeChange(size){
        this.pageSize = size
        this.$emit('handleEventGetListFile' ,this.dataList.folderId,null,null,size)
    },

    handleCurrentChange(size){
        this.$emit('handleEventGetListFile' ,this.dataList.folderId,null,size,null)
        this.pageNo = size
    },


    handleSelectionChange(val){
        
        // if (val.length > this.dowNum) {
        //   this.$message.error(`您当前只能支持下载${this.dowNum}个文件`)  
        // } else {
            this.fileUrlList = []
            this.fileNameList = []
            this.fileid = []
            this.fileids = []
        val.map((item)=>{
            this.fileUrlList.push(item.fileUrl)
            this.fileNameList.push(item.fileName)
            this.fileid.push(item.id)
            // this.fileids.push(item.fileId)
        }) 
        // }
        
    },

    clickBatchDownload() {
        if (this.dowNum <= 0) {
            this.$message.error(`您目前剩余下载数量为${this.dowNum}个文件`)
        } else {
        let data = {
            callerType: 1,
            fileId:this.fileid.join(),
            consumeNum: this.fileid.length,
            downloadType:2,
        }
        this.$axios.post(`${apiBaseUrl}/fileDownload/fileDownloadRecord`, data,{
            headers:{
                'authorization':sessionStorage.getItem('tokenInfo')
            }
            }).then((res)=>{
                
            if(res.data.code === 200){
                this.batchDownload(this.fileUrlList, this.fileNameList, this.dowNum);
                // this.$emit('handleEventGetListFile' ,this.dataList.folderId,)
                this.getDownum()
                    
            }else{
                this.$message({
                type: "error",
                message: res.data.message,
            });
            }
            })  
        } 
},
    clickBatchMove(){
        if(this.fileid.length === 0){
            this.$message.warning('请先选择要移动的文件')
        }else{
            this.showfilesDing = true
        }
    },

    handleCheck(data,checked){
        
        if (checked.checkedKeys.includes(data.id)) {
            this.$refs.trees.setCheckedKeys([]);
            this.$refs.trees.setCheckedKeys([data.id]);
            this.checkedKeys = [data.id];
        } else {
            this.$refs.trees.setCheckedKeys([]);
            this.checkedKeys = [];
        }

    this.categoryId = data.folderId
    
    //   this.$axios.get(`${apiBaseUrl}/courseFolder/getFolder/${data.id}`,{
    //           headers:{
    //             'authorization':sessionStorage.getItem('tokenInfo')
    //           }
    //         }).then((res)=>{
    //           if(res.data.code === 200){
    //             this.$refs.tree.setCheckedKeys([]);
    //             if(res.data.data !== null){
    //               const checkedKeys = res.data.data.folderId.split(',');
    //               // this.$refs.tree.setCheckedKeys(checkedKeys,false);
    //               checkedKeys.forEach(key => {
    //                 this.$refs.tree.setChecked(key, true, false);
    //               });
    //             }else{
    //               this.$refs.tree.setCheckedKeys([]);

    //             }
               
    //           }else{
    //             this.$message({
    //             type: "error",
    //             message: res.data.message,
    //           });
    //           }
    //         })
    
    },

    handleClickOk(){
        let data ={
            fileList:this.fileid,
            folderId:this.categoryId,
        }
        

        this.$axios.post(`${apiBaseUrl}/file/batchMove`,data,{
            headers:{
                'authorization':sessionStorage.getItem('tokenInfo')
            }
            }).then((res)=>{
            if(res.data.code === 200){
                
                this.showfilesDing = false
                this.$refs.trees.setCheckedKeys([]);
                this.$message.success(res.data.message)  
                this.$emit('handleEventGetListFile' ,this.dataList.folderId)      
            }else{
                this.$message({
                type: "error",
                message: res.data.message,
            });
            }
            })
    },

        downloadFile(url, fileName) {
            const replacedString = url.replace('+', '%2B');
            const replacedStrings = this.upgradeToHttps(replacedString);
            const fileExtension = url.split('.').pop().toLowerCase();

            return fetch(replacedStrings)
                .then(response => response.blob())
                .then(blob => {
                    const link = document.createElement('a');
                    const url = window.URL.createObjectURL(blob);
                    link.href = url;

                    if (!fileName.toLowerCase().endsWith('.' + fileExtension)) {
                        fileName += '.' + fileExtension;
                    }

                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                });
        },

        // batchDownload(urls, fileNames) {
        //     Promise.all(urls.map((url, index) => this.downloadFile(url, fileNames[index])))
        //         .then(() => {
        //             this.$refs.tables.clearSelection()
        //             this.$message.success('多个文件下载成功~') 
        //         })
        //         .catch(error => {
        //             this.$refs.tables.clearSelection()
        //             this.$message.error('下载过程中发生错误~')
        //         });
        // },
        batchDownload(urls, fileNames, maxFiles) {
    
        const limitedUrls = urls.slice(0, maxFiles);
        const limitedFileNames = fileNames.slice(0, maxFiles);

        this.isDownloading = true;

        Promise.all(limitedUrls.map((url, index) => this.downloadFile(url, limitedFileNames[index])))
            .then(() => {
                this.$refs.tables.clearSelection();
                if (urls.length > maxFiles) {
                    this.$message.success(`成功下载前 ${maxFiles} 个文件。超出限制的文件未下载。`);
                } else {
                    this.$message.success('多个文件下载成功~');
                }
            })
            .catch(error => {
                console.error('下载错误:', error);
                this.$refs.tables.clearSelection();
                this.$message.error('下载过程中发生错误~');
            })
            .finally(() => {
                this.isDownloading = false;
            });
},



}
}

</script>


<style lang="less" scoped>

    .btn{
        background-color: #1890ff;
        border-color: #1890ff;
    }

    /deep/ .el-card__body{
        padding: 0px;
    }

    /deep/ .el-input__inner{
        height: 30px;
    }

    /deep/ .el-input__prefix{
        margin-top: -5px;
    }


    /deep/ .el-tree-node.is-current > .el-tree-node__content{
        color: #1890ff;
        background: #e8f4ff;
    }

    .add:hover{
        padding: 10px 10px;
        background: #4992df;
        color: #fff;
        border-radius: 5px;
    }

    /deep/ .el-drawer__header{
        font-weight: 900;
        font-size: 18px;
        background: #f5f7fa;
        padding: 15px 20px;
    }

    /deep/.el-divider--horizontal{
        margin-top: -26px;
    }

    /deep/ .el-dialog__header{
        text-align: start;
    }

    /deep/ .el-drawer__header{
        text-align: start;
    }

    /deep/ .el-input__suffix-inner{
        display: flex;
        margin-top: -3px;
    }

    /deep/ .el-range__close-icon{
        position: absolute;
        right: 0px;
    }
    /deep/ .el-range-separator{
        margin-top: -10px;
    }

    /deep/ .el-icon-date{
        display: none;
    }
    .no_click {
        pointer-events: none;
    }



</style>
























// WEBPACK FOOTER //
// src/FileSpace/searchTable.vue